// extracted by mini-css-extract-plugin
export var image = "Image-module--image--3aa31";